import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { RootState } from "../store";

const baseQuery = fetchBaseQuery({
  baseUrl: "https://api.jiffyhq.com/api/v1/",
  prepareHeaders: (headers, { getState }) => {
    return headers;
  },
});


export const apiSlice = createApi({
  baseQuery: baseQuery,
  reducerPath: "api",
  endpoints: (builder) => ({}),
});
